/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type DataUpdateNeededQueryWrapperQueryVariables = {
    readonly participant_id?: string | null;
};
export type DataUpdateNeededQueryWrapperQueryResponse = {
    readonly participants: ({
        readonly participant: ReadonlyArray<({
            readonly data_update_needed: boolean | null;
        }) | null> | null;
    }) | null;
};
export type DataUpdateNeededQueryWrapperQuery = {
    readonly response: DataUpdateNeededQueryWrapperQueryResponse;
    readonly variables: DataUpdateNeededQueryWrapperQueryVariables;
};



/*
query DataUpdateNeededQueryWrapperQuery(
  $participant_id: String
) {
  participants(id: $participant_id) {
    participant {
      data_update_needed
      id
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "participant_id",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "participant_id"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "data_update_needed",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "DataUpdateNeededQueryWrapperQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "participants",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Pagination",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "participant",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Participant",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "DataUpdateNeededQueryWrapperQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "participants",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Pagination",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "participant",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Participant",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "id",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "DataUpdateNeededQueryWrapperQuery",
            "id": null,
            "text": "query DataUpdateNeededQueryWrapperQuery(\n  $participant_id: String\n) {\n  participants(id: $participant_id) {\n    participant {\n      data_update_needed\n      id\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '5a5e9c06ef7ffe5230c2152d322df8c8';
export default node;
